module.exports = new __parcel__URL__("objectives_rect.1fc5e4a5.png").toString();